import axios from './axios'
import VirtualBankLineItem from 'Models/VirtualBankLineItem'
import BaseDataService from 'DataServices/BaseDataService'

export function baseIndexUrlString () {
  return `/virtual_bank_line_items`
}

class VirtualBankLineItems extends BaseDataService {
  async getAll (params) {
    return axios.get(baseIndexUrlString(), { params: params })
      .then(response => response.data)
      .then(respData => {
        return Promise.all(respData.data.map(async vba => {
          return newVirtualBankLineItem(vba)
        }))
          .then(vbas => {
            return { data: vbas, links: respData.links }
          })
      })
      .catch(console.error)
  }
}

function newVirtualBankLineItem (data) {
  return new VirtualBankLineItem(data)
}

export default new VirtualBankLineItems()
